interface Translation {
  letter: string;
  symbol: string;
}

export const getSymbol = (
  letter: string,
  translations: Translation[]
): string | undefined => {
  const translation = translations?.find((t) => t.letter === letter);
  return translation?.symbol;
};
